import {fetch_retry_post, fetch_retry_put } from "../redux/actions/ApiManager";
import { getEnv } from "../enviroment";
const { base } = getEnv();
    const createUser = async(payload) =>  {
        try {
        let response = await fetch_retry_post(`${base}/user`,payload);
        if(response.status === 400){
          return { success: false, message:response.data.error };
        }
        if (response.status === 200 || response.status === 201) {
            return { success: true, data:response.data };
        } else {
            return { success: false, message:response.data.message };
        }
        } catch (error) {
          console.error("error", error);
          return { success: false, message:error.data };
        }
    };

  const getUserList = async(payload) =>  {
    try {
      let response = await fetch_retry_post(`${base}/user/list`,payload);
      if (response.status === 200 || response.status === 201) {
        return { success: true, data:response.data };
      } else {
        return { success: false, message:response.data.message };
      }
    } catch (error) {
      console.error("error", error);
      return { success: false, message:error.data };
    }
  };


  const activeUser = async(id,status) =>  {
    try {
      let response = await fetch_retry_put(`${base}/user/${id}/change-status`,status);
      if (response.status === 200 || response.status === 201) {
        return { success: true, data:response.data };
      } else {
        return { success: false, message:response.data.message };
      }
    } catch (error) {
      console.error("error", error);
      return { success: false, message:error.data };
    }
  };

  const getRoleList = async(payload) =>  {
    try {
      let response = await fetch_retry_post(`${base}/role/list`,payload);
      if (response.status === 200 || response.status === 201) {
        return { success: true, data:response.data };
      } else {
        return { success: false, message:response.data.message };
      }
    } catch (error) {
      console.error("error", error);
      return { success: false, message:error.data };
    }
  };

  const activeUserRole = async(id,status) =>  {
    try {
      let response = await fetch_retry_put(`${base}/role/${id}/change-status`,status);
      if (response.status === 200 || response.status === 201) {
        return { success: true, data:response.data };
      } else {
        return { success: false, message:response.data.message };
      }
    } catch (error) {
      console.error("error", error);
      return { success: false, message:error.data };
    }
  };
  export const userService = {
    getUserList,
    activeUser,
    createUser,
    getRoleList,
    activeUserRole
  };
  